'use client';

import React from 'react';
import { Heading, Flex, VStack } from '@chakra-ui/react';
import CustomerTestimonialsSwiper from './components/CustomerTestimonialsSwiper';
import CustomerTestimonialsSwiperSkeleton from './components/CustomerTestimonialsSwiperSkeleton';
import SectionContainer from '@/components/shared/SectionContainer';
import QueryBoundary from '@/components/ui/QueryBoundary';

const CustomerTestimonialsSection = () => {
  return (
    <SectionContainer
      containerWrapperProps={{
        backgroundColor: 'common.100',
        paddingY: { base: 12, tablet: 12, desktop: 12 },
      }}
    >
      <VStack gap={8} width="100%">
        <Flex alignSelf="stretch" alignItems="center">
          <Heading as="h2" color="neutral.90" fontWeight="regular" textStyle="heading2">
            What Our Customers Say
          </Heading>
        </Flex>

        <QueryBoundary loadingFallback={<CustomerTestimonialsSwiperSkeleton />}>
          <CustomerTestimonialsSwiper />
        </QueryBoundary>
      </VStack>
    </SectionContainer>
  );
};

export default CustomerTestimonialsSection;
